/**
 * Big Black Horse - Premium Menu Hover Enhancement
 * Enables luxury-style hover dropdowns on desktop while maintaining click functionality
 */

(function() {
  'use strict';

  // Only run on desktop
  if (window.innerWidth < 990) return;

  function initMenuHover() {
    const menuDetails = document.querySelectorAll('.header__inline-menu details');
    
    menuDetails.forEach(details => {
      let hoverTimeout;
      
      // On mouse enter, open the menu
      details.addEventListener('mouseenter', function() {
        clearTimeout(hoverTimeout);
        
        // Close other open menus
        menuDetails.forEach(otherDetails => {
          if (otherDetails !== details && !otherDetails.contains(details)) {
            otherDetails.removeAttribute('open');
          }
        });
        
        // Open this menu
        this.setAttribute('open', '');
      });
      
      // On mouse leave, close after a short delay
      details.addEventListener('mouseleave', function() {
        const self = this;
        hoverTimeout = setTimeout(() => {
          self.removeAttribute('open');
        }, 200); // Small delay to allow moving between menu and submenu
      });
      
      // Prevent the summary click from toggling (we handle it with hover)
      const summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function(e) {
          // On desktop, prevent default click behavior
          if (window.innerWidth >= 990) {
            e.preventDefault();
          }
        });
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuHover);
  } else {
    initMenuHover();
  }
  
  // Reinitialize on window resize if crossing the mobile/desktop threshold
  let wasDesktop = window.innerWidth >= 990;
  window.addEventListener('resize', function() {
    const isDesktop = window.innerWidth >= 990;
    if (isDesktop !== wasDesktop) {
      wasDesktop = isDesktop;
      if (isDesktop) {
        initMenuHover();
      }
    }
  });
})();
